import { render, staticRenderFns } from "./TiktokCampaings.vue?vue&type=template&id=e9072822&scoped=true&"
import script from "./TiktokCampaings.vue?vue&type=script&lang=js&"
export * from "./TiktokCampaings.vue?vue&type=script&lang=js&"
import style0 from "./TiktokCampaings.vue?vue&type=style&index=0&id=e9072822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9072822",
  null
  
)

export default component.exports